import axios from 'axios';
import { captureFrontendException } from '../sentry.js';

const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL
});

function shouldReportFrontendApiError(error) {
  if (isRequestCanceled(error)) return false;
  if (!error) return false;

  const status = Number(error?.response?.status || 0);
  if (!status) return true;
  return [401, 403, 404, 409, 422, 429].includes(status) || status >= 500;
}

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (shouldReportFrontendApiError(error)) {
      captureFrontendException(error, {
        kind: error?.response ? 'http' : 'network',
        statusCode: error?.response?.status || 0,
        method: error?.config?.method || '',
        url: error?.config?.url || '',
        code: error?.code || error?.response?.data?.error?.code || null,
        responseData: error?.response?.data || null,
        path: typeof window !== 'undefined' ? window.location.pathname : ''
      });
    }
    return Promise.reject(error);
  }
);

export function unwrapApiResponse(response) {
  return response?.data?.data;
}

export function isRequestCanceled(error) {
  return axios.isCancel?.(error) || error?.code === 'ERR_CANCELED' || error?.name === 'CanceledError';
}

export function extractApiError(error, fallbackMessage = 'Ocurrió un error') {
  if (isRequestCanceled(error)) return '';
  return error?.response?.data?.error?.message || error?.response?.data?.message || fallbackMessage;
}

export async function downloadApiFile(url, token, filenameFallback = 'archivo') {
  const response = await api.get(url, {
    headers: { Authorization: `Bearer ${token}` },
    responseType: 'blob'
  });

  const blob = new Blob([response.data]);
  const objectUrl = window.URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  const header = response.headers['content-disposition'] || response.headers['Content-Disposition'] || '';
  const fileNameMatch = header.match(/filename\*?=(?:UTF-8''|")?([^";]+)/i);
  const fileName = decodeURIComponent((fileNameMatch?.[1] || filenameFallback).replace(/"/g, '').trim());
  anchor.href = objectUrl;
  anchor.download = fileName || filenameFallback;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  window.URL.revokeObjectURL(objectUrl);
}

export default api;
